export default {
    name: "breadcrumbs",
    props: {
        list: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            params: {
                title: '',
                description: '',
                keywords: '',
                image: '',
            },
        }
    },
    // BreadcrumbList выводит сервер (App\Seo\Schema\BreadcrumbsBuilder).
    // Здесь разметка строилась из window.location и была невалидной:
    // position нумеровался с нуля, а item собирался без схемы —
    // "karbosnab.com/katalog" вместо "https://karbosnab.com/katalog".
    watch: {
        '$route'() {
            this.setMeta()
        },
        product: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.setMeta()
                }
            }
        }
    },
    mounted() {
    },
    created() {

    },
    methods: {
        goToPage(page) {
            this.$router.push({name: page}).catch(() => {
                console.log()
            })
        },
        setMeta() {
            this.$emit('updateHead');
        },
    }
}
